import React, { useEffect, useRef, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import Divider from "../Divider/Divider";

const Accordion = ({
  title,
  content,
  className,
  openedByDefault = false,
  transition = true,
  titlePadding = "p-2",
  contentPadding = "p-2 py-3",
  showLine = false,
  arrowColor = "text-white",
}) => {
  const [isActive, setIsActive] = useState(false);
  const [height, setHeight] = useState("0px");
  const [rotate, setRotate] = useState("transform duration-500 ease");
  const busy = useRef(false);

  const contentRef = useRef(null);

  function toggleAccordion() {
    if (busy.current) {
      return;
    }
    busy.current = true;
    setTimeout(() => {
      busy.current = false;
    }, 300);
    setIsActive(isActive === false ? true : false);
    setHeight(
      isActive
        ? "0px"
        : `${contentRef?.current ? contentRef?.current?.scrollHeight : 0}px`
    );
    setRotate(
      isActive
        ? "transform duration-300 ease"
        : "transform duration-300 ease rotate-180"
    );
  }

  useEffect(() => {
    if (openedByDefault) {
      toggleAccordion();
    }
  }, [openedByDefault]);

  useEffect(() => {
    if (!contentRef.current) return;

    setHeight(isActive ? `${contentRef.current.scrollHeight}px` : "0px");
  }, [content, isActive]);

  return (
    <div className={`${className} flex flex-col`}>
      <div
        className={`${titlePadding} box-border flex cursor-pointer appearance-none items-center gap-1 justify-between focus:outline-none`}
        onClick={toggleAccordion}
      >
        <div className="w-full text-left">{title}</div>

        <RiArrowDownSLine className={`text-xl ${rotate} ${arrowColor}`} />
      </div>

      <div
        className={`transition-max-height overflow-auto ${
          transition ? "duration-500 ease-in-out" : ""
        }`}
        ref={contentRef}
        style={{ maxHeight: height, overflow: "hidden" }}
      >
        {showLine && <Divider color="gray200" type="horizontal" />}
        <div className={`${contentPadding} flex flex-col`}>{content}</div>
      </div>
    </div>
  );
};

export default Accordion;
